// extracted by mini-css-extract-plugin
export default {"primaryBttn":"PrimaryBttn_primaryBttn__ntYS5"};